import axios from 'axios';
import FeatureFlagEntity from './feature-flags-entity';

class FeatureFlagsService {

  hydrate (featureFlag) {
    return new FeatureFlagEntity(
      featureFlag.id,
      featureFlag.name,
      featureFlag.value,
    );
  }

  hydrateCollection (data) {
    var features = [];

    for (let feature of data) {
      features.push(this.hydrate(feature));
    }

    return features;
  }

  getStoryblokFeatureFlags () {
    const cacheBuster = '&cv=' + Date.now();
    // eslint-disable-next-line max-len
    return axios.get('https://api.storyblok.com/v2/cdn/datasource_entries?datasource=feature-flags&token=zmSiv98DssZf7fOvJqKPdQtt' + cacheBuster)
      .then(
        (response) => {
          var features = this.hydrateCollection(response.data.datasource_entries);
          return features;
        }
      );
  }

}

export default new FeatureFlagsService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/feature-flags/feature-flags-service.js
 **/